module.exports = __webpack_public_path__ + "img/img2.214a82f8.png";